import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { useReportAsSafeViaWebUi } from '~/hooks/api/useReportAsSafeViaWebUi';
import messages from './messages';

type ReportAsSafeProps = {
  publisherId: number;
};

const ReportAsSafeButton = (props: ReportAsSafeProps) => {
  const mutation = useReportAsSafeViaWebUi();
  return (
    <Button
      variant="contained"
      color="success"
      onClick={() => {
        mutation.mutate({ publisherId: props.publisherId });
      }}
    >
      <FormattedMessage {...messages.reportAsSafe} />
    </Button>
  );
};

export default ReportAsSafeButton;
